import { Component, OnInit } from '@angular/core';
import { Router, Event } from '@angular/router';
import { LoaderService } from 'src/app/Service/Common/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  loadingprogress: boolean = false
  progressValue: number = 0;
  stopProgress: boolean;
  progressColor: string;
  width: number = 10;

  constructor(
    private loaderService: LoaderService,
    private router: Router
  ) { 
    this.loaderService.isLoading.subscribe((v) => {
      this.loadingprogress = v;
    });

    router.events.subscribe((event: Event) => {
      this.navigationObserver(event);
    });
  }

  ngOnInit(): void {
  }

  private navigationObserver(event: Event): void {

  }

}
